import Api from ".";
import { DEVURL } from "./envUrl";

export const getChangeHandlingData = async (payload) => {
  const api = new Api();
  const axiosInstance = await api.init({
    headers: {
      'Content-Type': 'application/json',
    },
  });
  const apiURL = `${DEVURL}/fetchChangesInAttributes`;
  try {
    const response = await axiosInstance({
      url: apiURL,
      method: 'POST',
      data: payload, // Pass as object, not string
      headers: {
        'Content-Type': 'application/json',
      },
    });
    if (response?.status === 200) {
      return response.data;
    }
    return { error: `Unexpected response status: ${response?.status}` };
  } catch (error) {
    if (error.response) {
      console.error('ChangeHandling API error response:', error.response.data);
    }
  }
};

// Refresh POA API call
export const refreshPOA = async (poaNumbers = []) => {
  const api = new Api();
  const axiosInstance = await api.init({
    headers: {
      'Content-Type': 'application/json',
    },
  });
  const apiURL = `${DEVURL}/refreshPOA`;
  const requestBody = {
    POAList: poaNumbers.map(num => ({ POANumber: num }))
  };
  try {
    const response = await axiosInstance({
      url: apiURL,
      method: 'POST',
      data: requestBody,
      headers: {
        'Content-Type': 'application/json',
      },
    });
    if (response?.status === 200) {
      const status = response.data?.Status;
      if (status && status.Code === "0") {
        return { success: true, message: status.Message };
      } else if (status && status.Code === "1") {
        return { success: false, message: status.Message };
      } else if (status) {
        return { success: false, message: status.Message };
      }
      return { success: false, message: 'Unknown response format.' };
    }
    return { success: false, error: `Unexpected response status: ${response?.status}` };
  } catch (error) {
    if (error.response) {
      console.error('refreshPOA API error response:', error.response.data);
    }
    return { success: false, error: error.message || 'API call failed' };
  }
};

//Get POA History API call
export const getHistoryData = async(payload)=>{
const api = new Api();
  const axiosInstance = await api.init({
    headers: {
      'Content-Type': 'application/json',
    },
  });
  const apiURL = `${DEVURL}/fetchHistoricalChangesInAttributes`;
  try {
    const response = await axiosInstance({
      url: apiURL,
      method: 'POST',
      data: payload, // Pass as object, not string
      headers: {
        'Content-Type': 'application/json',
      },
    });
    if (response?.status === 200) {
      return response.data;
      
    }
    return { error: `Unexpected response status: ${response?.status}` };
  } catch (error) {
    if (error.response) {
      console.error('getHistoryData API error response:', error.response.data);
    }
  }
}


export const saveConfirmDetails = async (payload) => {
  const api = new Api();
  const axiosInstance = await api.init({
    headers: {
      'Content-Type': 'application/json',
    },
  });
  const apiURL = `${DEVURL}/acceptAttributeChanges`;

  try {
    const response = await axiosInstance({
      url: apiURL,
      method: 'POST',
      data: payload, // Pass as object, not string
    });
    if (response?.status === 200) {
      const status = response.data?.Status;
      if (status && status.Code === "0") {
        return { success: true, message: status.Message };
      } else if (status && status.Code === "1") {
        return { success: false, message: status.Message };
      } else if (status) {
        return { success: false, message: status.Message };
      }
      return { success: true, data: response.data };
    }
    return { success: false, error: `Unexpected response status: ${response?.status}` };
  } catch (error) {
    if (error.response) {
      console.error('saveConfirmDetails API error response:', error.response.data);
    }
    return { success: false, error: error.message || 'API call failed' };
  }
};

//API call to show  CIC Full Kit data
export const getEachFullKitConditionValidation = async (
  ProjectID,
  BU,
  Region,
  DSBP_InitiativeID,
  PIMaterialID,
  PIMaterialNumber,
  taskId,
  headers = {}
) => {
  const api = new Api();
  const axiosInstance = await api.init({ headers });
  let apiURL = `${DEVURL}/eachFullKitConditionValidation/${ProjectID}/${BU}/${Region}/${DSBP_InitiativeID}/${PIMaterialID}/${PIMaterialNumber}/${taskId}`;

  const addResponse = await axiosInstance({
    url: apiURL,
    method: 'GET',
  });
  let response = addResponse?.data?.FullkitChecklist;
  return response;
};
//API call to show  FA Full Kit data
export const getEachFAFullKitConditionValidation = async (
  ProjectID,
  BU,
  Region,
  DSBP_InitiativeID,
  PIMaterialID,
  PIMaterialNumber,
  headers = {}
) => {
  const api = new Api();
  const axiosInstance = await api.init({ headers });
  let apiURL = `${DEVURL}/getEachFAFullKitConditionValidation/${ProjectID}/${BU}/${Region}/${DSBP_InitiativeID}/${PIMaterialID}/${PIMaterialNumber}`;

  const addResponse = await axiosInstance({
    url: apiURL,
    method: 'GET',
  });
  let response = addResponse?.data?.FullkitChecklist;
  return response;
};